import apiV2Service from '../api/api-v2.service';
import {PostDataObj} from '../api/apiTypes';
import {
  CreateAiContentProjectRequest,
  RemoteAiContentProject,
  UpdateAiContentProjectRequest,
  UpdateGenerationSetupRequest,
} from './aiContentProject.types';

const BASE_PATH = 'ai-content-projects';

async function getAiContentProjects(): Promise<RemoteAiContentProject[]> {
  const {data} = await apiV2Service.executeGetRequest<RemoteAiContentProject[]>(
    BASE_PATH,
  );

  return data;
}

async function getAiContentProjectById(
  id: number,
): Promise<RemoteAiContentProject> {
  const {data} = await apiV2Service.executeGetRequest<RemoteAiContentProject>(
    `${BASE_PATH}/${id}`,
  );

  return data;
}

async function createAiContentProject(
  request: CreateAiContentProjectRequest,
): Promise<number> {
  const {data} = await apiV2Service.executePutRequest<number>(BASE_PATH, {}, request as PostDataObj);

  return data;
}

async function updateAiContentProject({
  id,
  request,
}: {
  id: number;
  request: UpdateAiContentProjectRequest;
}): Promise<void> {
  await apiV2Service.executePutRequest<void>(`${BASE_PATH}/${id}`, {}, request as PostDataObj);
}

async function deleteAiContentProject(id: number): Promise<void> {
  await apiV2Service.executeDeleteRequest<void>(`${BASE_PATH}/${id}`);
}

async function updateGenerationSetup({
  projectId,
  request,
}: {
  projectId: number;
  request: UpdateGenerationSetupRequest;
}): Promise<void> {
  await apiV2Service.executePutRequest<void>(
    `${BASE_PATH}/${projectId}/generation-setup`,
    {},
    request as unknown as PostDataObj,
  );
}

const aiContentProjectApi = {
  getAiContentProjects,
  getAiContentProjectById,
  createAiContentProject,
  updateAiContentProject,
  deleteAiContentProject,
  updateGenerationSetup,
};

export default aiContentProjectApi;

